import HTTP from './HTTP';

export default { HTTP };
